import { render, staticRenderFns } from "./AuthorizedRequestorAuthorize.vue?vue&type=template&id=00cd0a54"
import script from "./AuthorizedRequestorAuthorize.vue?vue&type=script&lang=js"
export * from "./AuthorizedRequestorAuthorize.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedRequestorAuthorize.vue?vue&type=style&index=0&id=00cd0a54&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports